import { forwardRef, useCallback } from 'react';
import { CatalogSearch } from '../../data/CatalogSearch';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { useContentNavigationDispatch, useContentSelectionDispatch } from '../providers';
import bundle from './NovaContent-ContentSearchField-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const ContentSearchField = /*#__PURE__*/forwardRef(function ContentSearchField(props, ref) {
  const localize = useTextLocalizer();
  const navDispatch = useContentNavigationDispatch();
  const selectionDispatch = useContentSelectionDispatch();
  const onSearch = useCallback((query, indices) => {
    // For the content components "doing a search" really just means setting the current location
    // to a search location, which the components will then respond to accordingly via the nav provider
    const location = {
      type: 'searchLocation',
      value: {
        name: query,
        searchQuery: query,
        idQualifier: getUniqueIdQualifier(query)
      }
    };
    navDispatch?.(prev => ({
      ...prev,
      location,
      locationContextPath: [location]
    }));
    selectionDispatch?.([]);
    props.onSearch?.(query, indices);
  }, [navDispatch, props, selectionDispatch]);
  return /*#__PURE__*/_jsx(CatalogSearch, {
    ref: ref,
    initialQuery: props.initialQuery,
    enableExperimental: false,
    onCurrentSearchIndicesChanged: () => {},
    ...props,
    placeholder: props.placeholder ?? localize('content.placeholder.label'),
    onSearch: onSearch,
    onClearSearch: props.onClearSearch
  });
});
const uniqueIdQualifierMap = new Map();

// Generate a unique idQualifier by adding an incremented value tracked in a map. Will grow over
// time, but should not be unreasonable due to limited nature of searches per session
const getUniqueIdQualifier = query => {
  const nextUniqueNum = uniqueIdQualifierMap.get(query);
  if (nextUniqueNum) {
    uniqueIdQualifierMap.set(query, nextUniqueNum + 1);
    return `${query} ${nextUniqueNum}`;
  } else {
    uniqueIdQualifierMap.set(query, 1);
    return `${query}`;
  }
};
//# sourceMappingURL=ContentSearchField.js.map